// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ow5b","rootCenter":"LoadMoreObserver_rootCenter__PS1Cc","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1x0Tr"};